// extracted by mini-css-extract-plugin
export var banner = "style-module--banner--wHzx0";
export var main = "style-module--main--MzMtL";
export var slidein = "style-module--slidein--0OdA8";
export var wrapper = "style-module--wrapper--kqOdX";